import { render, staticRenderFns } from "./ListRecord.vue?vue&type=template&id=5c07e194&"
import script from "./ListRecord.vue?vue&type=script&lang=ts&"
export * from "./ListRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports